// extracted by mini-css-extract-plugin
export default {"aboutContainer":"aboutMe_aboutContainer__yFJig","myImage":"aboutMe_myImage__JNiry","text":"aboutMe_text__Um8LM"};